export const REFERRAL_PAYMENT_TYPE = {
  LENDER: 0,
  BROKER: 1,
  NO_COMMISSION_PAID: 2,
};
